import { IBlogPostType } from 'constants/types';
import { useQuery } from 'hooks/useQuery';
import { getBlogPostById, listBlogPosts } from 'lib/api/blog';
import { HookQueryOptions, queryKey } from './shared';

interface PostsRequest {
  category?: string;
  limit?: number;
  isTop?: boolean;
  type?: IBlogPostType;
}

export const usePostByIdQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery(
    queryKey('blogPost.byId', payload),
    () => getBlogPostById(payload.id),
    { skip: options?.skip || !payload?.id }
  );

export const usePostsQuery = (
  payload: PostsRequest = {},
  options?: HookQueryOptions
) =>
  useQuery(queryKey('blogPost.list', payload), () => listBlogPosts(payload), {
    skip: options?.skip,
  });
